/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { DenseMatrixDependencies } from './dependenciesDenseMatrixClass.generated';
import { equalScalarDependencies } from './dependenciesEqualScalar.generated';
import { matrixDependencies } from './dependenciesMatrix.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createMod } from '../../factoriesAny.js';
export var modDependencies = {
  DenseMatrixDependencies: DenseMatrixDependencies,
  equalScalarDependencies: equalScalarDependencies,
  matrixDependencies: matrixDependencies,
  typedDependencies: typedDependencies,
  createMod: createMod
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesMod.generated.js
// module id = 1456
// module chunks = 0